var React = require('react');

function ArrRightTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.31005 1.70005L0.999995 1.70005L0.999995 0.300049L11 0.300049L11.7 0.300049V1.00005L11.7 11H10.3L10.3 2.69L1.49497 11.495L0.50502 10.5051L9.31005 1.70005Z","fill":"#303030"}));
}

ArrRightTop.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrRightTop;

ArrRightTop.default = ArrRightTop;
